import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { Stethoscope, Shield, Zap, Clock, Volume2, BarChart3 } from 'lucide-react';

export default function HospitalsPage() {
  return (
    <SolutionPageTemplate
      slug="hospitals"
      title="BESS for Hospitals"
      subtitle="Healthcare & Hospitals"
      description="Critical, uninterrupted backup power for hospitals and healthcare facilities. Zero emissions, zero noise—because your patients deserve clean air and quiet recovery."
      heroImage="/images/voltide-hospital.png"
      path="/solutions/hospitals"
      sectorLabel="hospitals"
      useCaseParam="backup"
      benefits={[
        { icon: Zap, title: 'Critical Backup', desc: 'Millisecond switchover protects life-saving equipment, ventilators, and monitoring systems.' },
        { icon: Volume2, title: 'Silent Operation', desc: 'No diesel noise near patient wards, ICUs, or operating theatres.' },
        { icon: Shield, title: '99.5% Uptime SLA', desc: 'Guaranteed availability with 24/7 remote monitoring and proactive maintenance.' },
        { icon: Clock, title: 'Extended Runtime', desc: 'Configurable for 2-6+ hours of backup. Longer than most UPS systems.' },
        { icon: Stethoscope, title: 'Clean Air', desc: 'Zero exhaust emissions. No diesel particulates near patient areas.' },
        { icon: BarChart3, title: 'Peak Shaving', desc: 'Reduce peak demand charges while maintaining backup capability.' },
      ]}
      howItWorks={[
        { title: 'Load Assessment', desc: 'We map critical loads (OT, ICU, labs, elevators) and non-critical loads to size the optimal BESS.' },
        { title: 'Redundant Deployment', desc: 'System installed with redundancy for critical circuits. Tested with your existing transfer switches.' },
        { title: '24/7 Monitoring', desc: 'Real-time monitoring by Voltide NOC. Proactive alerts before any issue impacts operations.' },
      ]}
      faqs={[
        { q: 'Can BESS support critical medical equipment?', a: 'Yes. Our systems provide clean, stable power suitable for sensitive medical equipment including ventilators, monitors, and imaging systems. Millisecond switchover prevents any interruption.' },
        { q: 'What about regulatory compliance?', a: 'BESS systems are recognized by CBIP and relevant fire safety standards. We work with your compliance team to ensure all requirements are met.' },
        { q: 'How does it compare to our existing UPS + DG setup?', a: 'BESS replaces both—providing UPS-grade instant backup with DG-grade extended runtime. One system, simpler infrastructure, lower total cost.' },
      ]}
      productFilter={p => p.pcs_kw >= 250}
    />
  );
}
